module.exports = __webpack_public_path__ + "static/media/3_1.e9b07d85.png";